import type { PageRef } from '@wix/editor-platform-sdk-types'
import { getPatternDefForPage } from '@wix/wix-data-client-common'
import type {
  EditorSDK,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'

export const getPageRouteData = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}) => {
  const routerRef = await editorSdkProxy.routers.getByPage({ pageRef })

  const routerData = await editorSdkProxy.routers.get<RouterConfig>({
    routerRef,
  })

  const { pattern, def } = getPatternDefForPage(
    routerData.config,
    routerData.pages,
    pageRef,
  )

  return { routerData, pattern, definition: def }
}
